export default __webpack_public_path__ + "static/media/NoirPro-Bold.d790118f.woff";